import { useTranslations } from "@/lib/intl/use-translations"

interface Props {
  current: number
  total: number
}

export function ProgressIndicator({ current, total }: Props) {
  const t = useTranslations("quiz")
  const pct = Math.min(100, Math.round((current / total) * 100))
  const remaining = Math.max(0, total - current)
  // Switch to "almost there" copy once past the halfway mark — small carrot
  // for users who've already invested a few clicks.
  const pastHalf = current > total / 2 && remaining > 0
  return (
    <div className="space-y-2">
      <p className="type-body-sm text-neutral-500">
        {t("progress", { current: String(current), total: String(total) })}
        {pastHalf && (
          <>
            {" · "}
            <span className="text-deep-blue-700">
              {t("almostThere", { remaining: String(remaining) })}
            </span>
          </>
        )}
      </p>
      <div
        className="h-1.5 w-full overflow-hidden rounded-full bg-neutral-200"
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={total}
      >
        <div
          className="bg-deep-blue-900 h-full transition-[width] duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
